<template>
    <div>
        <div class="wrap">
            <!-- <div class="tabs">
                <div v-for="tab in tabs" :key="tab._id">
                    <div class="tab-item" :class="[
                        { active: selectTab._id === tab._id },
                        { checked: tab.checked }
                    ]" @click="onChangeTab(tab)">
                        {{ tab.name }}
                    </div>
                </div>
            </div> -->
            <div class="tab-pane">
                <el-tag v-for="(item, index) in tabs" :key="item._id" size="small" class="tag"
                    :type="item.checked ? '' : 'info'" @click="onSelectTag(index)">{{ item.name }}</el-tag>
            </div>
        </div>
    </div>



</template>
<script>
import { getSubCategories } from "@/api/material";

export default {
    name: "VideoTypeList",
    data() {
        return {
            tabs: [],
            selectTab: {},
        }
    },
    created() {
        this.getList();
    },
    methods: {
        // onChangeTab(tab) {
        //     this.selectTab = tab;
        // },
        onSelectTag(index) {
            this.tabs[index].checked = !this.tabs[index].checked;
        },
        async getList() {
            this.loading = true;
            const { status, data, message } = await getSubCategories({
                categoryId: "670e74efaf089a40acf16adb", // 视频id
                page: 1,
                pageSize: 100,
            });
            if (status == 10000) {
                this.tabs = data.map((item) => ({
                        checked: false,
                        ...item
                    }));
            } else {
                this.$message.error(message);
            }
            this.loading = false;
        },
        getCheckedList(){
            return this.tabs.filter(tab => tab.checked).map(({materials, ...rest}) => ({
                ...rest,
            }));
        }
    }
}
</script>
<style lang="scss" scoped>
.tabs {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    overflow-x: auto;

    .tab-item {
        // display: inline-block;
        margin-bottom: 20px;
        padding: 4px 10px;
        white-space: nowrap;

        &.active {
            color: #333333;
            font-weight: 600;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -12px;
                left: 50%;
                transform: translateX(-50%);
                width: 24px;
                height: 2px;
                border-radius: 1px;
                background-color: #1472ff;
            }
        }
        &.checked {
            color: #1472ff;
        }
    }

    &::-webkit-scrollbar {
        display: block;
        width: 8px;
        height: 6px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #ddd;
    }

    &::-webkit-scrollbar-track {
        background-color: #f5f5f5;
    }
}

.tab-pane {
    height: 120px;

    .tag {
        cursor: pointer;
        transition: none;
        &+.tag {
            margin-left: 10px;
        }
    }
}
</style>